import { render, staticRenderFns } from "./PreviewFileJSON.vue?vue&type=template&id=87471804"
import script from "./PreviewFileJSON.vue?vue&type=script&lang=js"
export * from "./PreviewFileJSON.vue?vue&type=script&lang=js"
import style0 from "./PreviewFileJSON.vue?vue&type=style&index=0&id=87471804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports